// Advisory password strength for the profile page's change-password form.
//
// IMPORTANT: this is guidance shown to the user, NOT a gate. The only rule the
// app enforces is MIN_PASSWORD_LENGTH (checked before submit) plus Firebase's
// own weak-password rejection — a "weak" score does not block a save. Keep it
// that way unless the submit check is tightened to match, otherwise the meter
// promises a rule nothing applies.
//
// Deliberately hand-rolled rather than pulling in zxcvbn: the whole scoring fits
// in a few lines, and zxcvbn's dictionary ships ~400KB into a bundle that only
// needs a three-step hint. Swap it in here if real scoring is ever wanted — the
// return shape is the only thing the UI depends on.

export const MIN_PASSWORD_LENGTH = 6;

const CHARACTER_CLASSES = [/[a-z]/, /[A-Z]/, /[0-9]/, /[^a-zA-Z0-9]/];

/**
 * @param {string} password
 * @returns {{ level: "none"|"weak"|"fair"|"strong", filled: 0|1|2|3 }}
 */
export function passwordStrength(password) {
  if (!password) return { level: "none", filled: 0 };

  const classes = CHARACTER_CLASSES.filter((re) => re.test(password)).length;
  const { length } = password;

  // Length carries most of the weight: a long passphrase beats a short password
  // with one of everything in it.
  if (length >= 14 && classes >= 2) return { level: "strong", filled: 3 };
  if (length >= 12 && classes >= 3) return { level: "strong", filled: 3 };
  if (length >= 10 && classes >= 2) return { level: "fair", filled: 2 };
  if (length >= 8 && classes >= 3) return { level: "fair", filled: 2 };

  return { level: "weak", filled: 1 };
}
